import { useEffect, useRef, useState } from "react";
import { t } from "@/i18n-js/instance";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { classNames } from "@/react/helpers/twMergeWithCN";

export const ConnectionNote = ({
  note,
  collapse = false,
  lineClamp = 3,
}: {
  note: string;
  collapse?: boolean;
  lineClamp?: number;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [shouldShowSeeMore, setShouldShowSeeMore] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!collapse || !textRef.current) return;

    const element = textRef.current;
    const isOverflowing = element.scrollHeight > element.clientHeight;
    setShouldShowSeeMore(isOverflowing);
  }, [note, collapse]);

  return (
    <div className="bg-secondary !mb-3 !mt-2 w-full rounded-xl px-3 py-2">
      <div className="relative">
        <div
          ref={textRef}
          // eslint-disable-next-line tailwindcss/no-custom-classname -- I'm dynamically setting the line clamp number
          className={classNames(
            collapse && "whitespace-pre-wrap",
            collapse && !isExpanded && `line-clamp-${lineClamp}`,
          )}
        >
          <Typography.BodyXs color="text-darkest" weight="normal">
            {note}
          </Typography.BodyXs>
        </div>
        {collapse && shouldShowSeeMore && !isExpanded && (
          <div className="bg-secondary absolute bottom-0 right-0 pl-2">
            <button
              type="button"
              onClick={() => setIsExpanded(true)}
              className="text-dark text-xs font-semibold"
            >
              {t("settings.connect.see_more")}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
